import { render, staticRenderFns } from "./match_single.vue?vue&type=template&id=542e6f2a&"
import script from "./match_single.vue?vue&type=script&lang=js&"
export * from "./match_single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports